import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, Box } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

function ConfirmDeleteModal({ open, onClose, onConfirm, title, message }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: 3,
          textAlign: "center",
          maxWidth: "420px",
          mx: "auto",
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box
            sx={(t) => ({
              backgroundColor: t.palette.error.light + "22",
              borderRadius: "50%",
              width: 72,
              height: 72,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            })}
          >
            <DeleteOutlineIcon color="error" fontSize="large" />
          </Box>
        </Box>

        <SoftTypography variant="h6" fontWeight="bold" gutterBottom>
          {title || "Er du sikker?"}
        </SoftTypography>
        <SoftTypography variant="body2" color="text" mb={3}>
          {message || "Vil du virkelig slette denne statusinnstillingen? Handlingen kan ikke angres."}
        </SoftTypography>

        <Box display="flex" justifyContent="center" gap={2}>
          <SoftButton onClick={onClose} variant="outlined" color="secondary" size="small">
            Avbryt
          </SoftButton>
          <SoftButton onClick={onConfirm} variant="gradient" color="error" size="small">
            Slett
          </SoftButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

ConfirmDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default ConfirmDeleteModal;
